import { render, staticRenderFns } from "./CatalogFilterTabs.vue?vue&type=template&id=cf4067bc&scoped=true"
import script from "./CatalogFilterTabs.vue?vue&type=script&lang=js"
export * from "./CatalogFilterTabs.vue?vue&type=script&lang=js"
import style0 from "./CatalogFilterTabs.vue?vue&type=style&index=0&id=cf4067bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4067bc",
  null
  
)

export default component.exports